var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.mode)?_c('GameList',{on:{"onChangeGameMode":_vm.changeGameMode}}):_vm._e(),(_vm.mode)?_c('GameStage',{attrs:{"mode":_vm.mode},on:{"onGameExit":_vm.closeGameMode}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }